module.exports = __webpack_public_path__ + "static/img/wnsxbg.5419ec7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wnsxbg.png
// module id = Gu5q
// module chunks = 1